/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadAdmissionStatusInfo
 */
export interface LeadAdmissionStatusInfo {
    /**
     * ID of the admission-status history row this info describes. Compare it with check-eligibility `admission_status_info_id` before offering an Undo.
     */
    id?: string;
    /**
     * 
     */
    action_effective_date?: string;
    /**
     * 
     */
    scheduled_action_effective_date?: string;
    /**
     * 
     */
    actioned_by?: string;
    /**
     * 
     */
    reason?: string;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    booked_by?: string;
    /**
     * 
     */
    booked_at?: string;
    /**
     * 
     */
    target_move_in_date?: string;
    /**
     * 
     */
    scheduled_move_out_date?: string;
    /**
     * 
     */
    hospitalized_date?: string;
    /**
     * 
     */
    hospitalized_by?: string;
    /**
     * 
     */
    bed_hold?: boolean;
    /**
     * 
     */
    bed_hold_end_date?: string;
    /**
     * 
     */
    move_in_date?: string;
    /**
     * 
     */
    move_out_date?: string;
    /**
     * 
     */
    bed_id?: string;
    /**
     * 
     */
    date_lost?: string;
    /**
     * 
     */
    lost_by?: string;
    /**
     * 
     */
    info_last_modified?: string;
    /**
     * 
     */
    moved_out_by?: string;
    /**
     * 
     */
    moved_in_by?: string;
    /**
     * 
     */
    loa_date?: string;
    /**
     * 
     */
    loa_by?: string;
    /**
     * 
     */
    stay_type?: LeadAdmissionStatusInfoStayTypeEnum;
    /**
     * 
     */
    readmitted_by_lead_id?: string;
}


/**
 * @export
 */
export const LeadAdmissionStatusInfoStayTypeEnum = {
    LongTerm: 'Long-Term',
    ShortTerm: 'Short-Term',
} as const;
export type LeadAdmissionStatusInfoStayTypeEnum = typeof LeadAdmissionStatusInfoStayTypeEnum[keyof typeof LeadAdmissionStatusInfoStayTypeEnum];


/**
 * Check if a given object implements the LeadAdmissionStatusInfo interface.
 */
export function instanceOfLeadAdmissionStatusInfo(value: object): value is LeadAdmissionStatusInfo {
    return true;
}

export function LeadAdmissionStatusInfoFromJSON(json: any): LeadAdmissionStatusInfo {
    return LeadAdmissionStatusInfoFromJSONTyped(json, false);
}

export function LeadAdmissionStatusInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAdmissionStatusInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'action_effective_date': json['action_effective_date'] == null ? undefined : json['action_effective_date'],
        'scheduled_action_effective_date': json['scheduled_action_effective_date'] == null ? undefined : json['scheduled_action_effective_date'],
        'actioned_by': json['actioned_by'] == null ? undefined : json['actioned_by'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'booked_by': json['booked_by'] == null ? undefined : json['booked_by'],
        'booked_at': json['booked_at'] == null ? undefined : json['booked_at'],
        'target_move_in_date': json['target_move_in_date'] == null ? undefined : json['target_move_in_date'],
        'scheduled_move_out_date': json['scheduled_move_out_date'] == null ? undefined : json['scheduled_move_out_date'],
        'hospitalized_date': json['hospitalized_date'] == null ? undefined : json['hospitalized_date'],
        'hospitalized_by': json['hospitalized_by'] == null ? undefined : json['hospitalized_by'],
        'bed_hold': json['bed_hold'] == null ? undefined : json['bed_hold'],
        'bed_hold_end_date': json['bed_hold_end_date'] == null ? undefined : json['bed_hold_end_date'],
        'move_in_date': json['move_in_date'] == null ? undefined : json['move_in_date'],
        'move_out_date': json['move_out_date'] == null ? undefined : json['move_out_date'],
        'bed_id': json['bed_id'] == null ? undefined : json['bed_id'],
        'date_lost': json['date_lost'] == null ? undefined : json['date_lost'],
        'lost_by': json['lost_by'] == null ? undefined : json['lost_by'],
        'info_last_modified': json['info_last_modified'] == null ? undefined : json['info_last_modified'],
        'moved_out_by': json['moved_out_by'] == null ? undefined : json['moved_out_by'],
        'moved_in_by': json['moved_in_by'] == null ? undefined : json['moved_in_by'],
        'loa_date': json['loa_date'] == null ? undefined : json['loa_date'],
        'loa_by': json['loa_by'] == null ? undefined : json['loa_by'],
        'stay_type': json['stay_type'] == null ? undefined : json['stay_type'],
        'readmitted_by_lead_id': json['readmitted_by_lead_id'] == null ? undefined : json['readmitted_by_lead_id'],
    };
}

export function LeadAdmissionStatusInfoToJSON(json: any): LeadAdmissionStatusInfo {
    return LeadAdmissionStatusInfoToJSONTyped(json, false);
}

export function LeadAdmissionStatusInfoToJSONTyped(value?: LeadAdmissionStatusInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'action_effective_date': value['action_effective_date'],
        'scheduled_action_effective_date': value['scheduled_action_effective_date'],
        'actioned_by': value['actioned_by'],
        'reason': value['reason'],
        'comment': value['comment'],
        'booked_by': value['booked_by'],
        'booked_at': value['booked_at'],
        'target_move_in_date': value['target_move_in_date'],
        'scheduled_move_out_date': value['scheduled_move_out_date'],
        'hospitalized_date': value['hospitalized_date'],
        'hospitalized_by': value['hospitalized_by'],
        'bed_hold': value['bed_hold'],
        'bed_hold_end_date': value['bed_hold_end_date'],
        'move_in_date': value['move_in_date'],
        'move_out_date': value['move_out_date'],
        'bed_id': value['bed_id'],
        'date_lost': value['date_lost'],
        'lost_by': value['lost_by'],
        'info_last_modified': value['info_last_modified'],
        'moved_out_by': value['moved_out_by'],
        'moved_in_by': value['moved_in_by'],
        'loa_date': value['loa_date'],
        'loa_by': value['loa_by'],
        'stay_type': value['stay_type'],
        'readmitted_by_lead_id': value['readmitted_by_lead_id'],
    };
}

